<template>
  <div class="ep">
    <el-row
      type="flex"
      justify="end"
      align="middle"
    >
      <sw-search
        placeholder="请输入流水号"
        @search="searchSerialNumber"
      />
      <el-date-picker
        v-model="date_choose"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        @change="dateChange"
      />
      <sw-search
        placeholder="请输入发起人"
        @search="search"
      />
    </el-row>

    <sw-table
      v-loading="loading"
      :table-name="'exp-manage'"
      :table-data="data.tableData2"
      :table-title="data.tableTitle2"
      :has-operation="true"
      :page-sizes="table_size"
      :total-count="total_count"
      :page-size="10"
      :table-operation="data.tableOperation2"
      :conflict-operation="data.conflictOperation2"
      :has-add-button="false"
      :show-selection="false"
      @operation-handle="operationHandle"
      @change-page="change_page"
      @size-change="size_change"
    >
      <template
        slot="customcolumn"
        slot-scope="scope"
      >
        <span
          v-if="scope.item.prop=='status'"
          :class="scope.row.status==='ing'?'sw-table-active':scope.row.status==='finished'?'sw-table-inactive':scope.row.status==='hang'?'sw-table-unpublish':'sw-table-closed'"
        >{{ scope.row.status==='ing'?'进行中':scope.row.status==='finished'?'办结':scope.row.status==='hang'?'挂起':'终止' }}</span>
        <span
          v-else
          :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
          class="swTableCell"
        >{{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}</span>
      </template>
    </sw-table>
    <sw-dialog
      :visible.sync="user_panel_data.show_user_choose"
      center
      append-to-body
      title="选择人员"
      width="870px"
    >
      <sw-search
        v-if="user_panel_data.show_user_choose"
        :placeholder="'请输入用户名/组织结构'"
        style="width:40%;margin-bottom:5px;"
        @search="search_user"
      />
      <div
        v-if="user_panel_data.show_user_choose"
        id="sw1"
        style="position:relative;margin-bottom:20x;max-height:calc(100vh - 300px);overflow-y:auto"
      >
        <sw-table
          v-loading="show_user_tf"
          :table-name="'tab-choose'"
          :table-data="data_choose.tableData"
          :table-title="data_choose.tableTitle"
          :page-sizes="table_size"
          :total-count="data_choose.total_count"
          :has-operation="false"
          :page-size="size_choose"
          :has-add-button="false"
          :show-selection="!type_con"
          @selection-change="handleChange"
          @change-page="change_page_choose"
          @size-change="size_change_choose"
        >
          <template
            slot="customcolumn"
            slot-scope="scope"
          >
            <span v-if="scope.item.prop=='choose'&&type_con">
              <el-radio
                v-model="keyword_radio"
                :label="scope.row.id"
                class="table_radio"
              />
            </span>
            <span
              v-else
              :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
              class="swTableCell"
            >
              {{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}
            </span>
          </template>
        </sw-table>
      </div>
      <div slot="footer">
        <div>
          <sw-button
            :laoding="btn_loading"
            :custom-button-size="9"
            type="primary"
            @click.stop="user_panel_data.callback()"
          >{{ user_panel_data.name }}</sw-button>
          <sw-button
            :custom-button-size="9"
            type="primary"
            @click.stop="user_panel_data.show_user_choose = false"
          >取 消</sw-button>
        </div>
      </div>
    </sw-dialog>
    <sw-dialog
      :visible.sync="th.visible"
      center
      append-to-body
      title="转办"
      destroy-on-close
    >
      任务所在人员：
      <UserList
        v-if="th.visible"
        ref="thTaskTable"
        :task-id="th.task_id"
      />
      <div style="margin-top:20px" />
      任务可转办人员：
      <SelectUser
        v-if="th.visible"
        ref="thUserTable"
      />
      <div slot="footer">
        <div>
          <sw-button
            :loading="th.loading"
            :custom-button-size="9"
            type="primary"
            @click="th_confirm"
          >转办</sw-button>
          <sw-button
            :custom-button-size="9"
            type="primary"
            @click.stop="th.visible = false"
          >取 消</sw-button>
        </div>
      </div>
    </sw-dialog>
    <sw-dialog
      :visible.sync="db_data.show_db"
      center
      append-to-body
      title="督办说明"
      width="500px"
    >
      <el-form v-if="db_data.show_db">
        <el-form-item
          label="实例名称"
          label-width="60px"
          style="white-space:nowrap;"
        >
          <el-input
            v-model="db_data.exp.act_form_name"
            disabled
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="当前节点"
          label-width="60px"
          style="white-space:nowrap;"
        >
          <el-input
            v-model="db_data.exp.taskName"
            disabled
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="督办说明"
          label-width="60px"
          style="white-space:nowrap;"
        >
          <el-input
            v-model.trim="db_data.keyword_db"
            :rows="4"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div style="margin-bottom:10px;">
          <sw-button
            :loading="btn_loading"
            :custom-button-size="9"
            type="primary"
            @click.stop="db_send()"
          >确定</sw-button>
          <sw-button
            :custom-button-size="9"
            simple
            @click.stop="db_data.show_db=false"
          >取消</sw-button>
        </div>
      </div>
    </sw-dialog>
    <sw-dialog
      :title="dialogTitle"
      :visible.sync="dialogIframeVisible"
      :destroy-on-close="true"
      :before-close="handleDialogClose"
      top="50px"
      width="calc(100% - 140px)"
    >
      <iframe
        id="formIframe"
        :src="iframeSrc"
        allow="fullscreen"
        style="border: none; width:  100%; height: calc(100vh - 145px)"
      />
    </sw-dialog>
  </div>
</template>
<script>
import service, { designFormUrl } from '@/utils/service.js'
import SelectUser from '../../components/userTable/selectUser'
import UserList from '../../components/userTable/userList'
export default {
  components: {
    SelectUser,
    UserList
  },
  data () {
    return {
      data: {},
      node_name: [],
      value_node_name: { value: 'quabu', label: '全部' },
      role_name: [],
      value_role_name: null,
      peo_name: [],
      value_peo_name: null,
      keyword_name: '', // 发起人
      keyword_serialnumber: '', // 流水号
      down_up: true,
      arr_button: [],
      tab2_creat_time: '',
      limit: 0,
      total_count: 0,
      user_panel_data: { show_user_choose: false, name: '转阅' },
      db_data: { show_db: false },
      date_choose: [],
      loading: false,
      instance_page: 1,

      selectlist: [],
      keyword_user_name: '',
      show_user_tf: false,
      search_user_tag: false,

      data_choose: {},
      size_choose: 10,
      // c_green: {"background":"green"}

      dialogTitle: '',
      dialogIframeVisible: false,
      iframeSrc: '',

      keyword_radio: '',
      type_con: false,

      btn_loading: false,
      th: {
        visible: false,
        task_id: '',
        loading: false
      }
    }
  },
  computed: {
    table_size () {
      return this.$store.state.app.tableSize
    },
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        this.get_instance(this.instance_page)
      }
    }
  },
  created () {
    this.node_name = [
      { value: 'quabu', label: '全部' },
      { value: '1', label: '节点二' },
      { value: '2', label: '节点三' },
      { value: '3', label: '节点四' },
      { value: '4', label: '节点五' }
    ]
    this.role_name = this.node_name
    this.peo_name = this.node_name

    this.arr_button = [
      { name: '终止', icon: 'su-icon-zhongzhi' },
      { name: '转阅', icon: 'su-icon-zhuanyue2' },
      { name: '挂起', icon: 'su-icon-guaqi' },
      { name: '激活', icon: 'su-icon-bulb' },
      { name: '督办', icon: 'su-icon-duban' },
      { name: '替换办理人', icon: 'su-icon-tihuanbanliren' }
    ]
    // tab2表头
    this.$set(this.data, 'tableTitle2', [
      { prop: 'serialNumber', label: '流水号', width: '120', sortable: true },
      { prop: 'creatorName', label: '发起人', width: '106', sortable: false },
      { prop: 'create_time', label: '发起时间', width: '200', sortable: false },
      { prop: 'taskName', label: '当前节点', width: '149', sortable: false },
      { prop: 'spendTime', label: '节点停留时长', width: '154', sortable: false },
      { prop: 'softGroup', label: '所属应用组', width: '142', sortable: false },
      { prop: 'status', label: '状态', width: '120', sortable: false }
    ])
    // tab2操作
    this.$set(this.data, 'tableOperation2', [
      { name: '表单详情', icon: 'su-icon-details', operation: 'detail' },
      { name: '督办', icon: 'su-icon-duban', operation: 'db' },
      { name: '激活', icon: 'su-icon-bulb', operation: 'jh' },
      { name: '终止', icon: 'su-icon-zhongzhi', operation: 'zz' },
      { name: '转阅', icon: 'su-icon-zhuanyue', operation: 'zy' },
      { name: '挂起', icon: 'su-icon-guaqi', operation: 'gq' },
      { name: '转办', icon: 'su-icon-tihuanbanliren', operation: 'th' }

      // {name: '删除', icon: 'su-icon-delete', operation: 'delete'},
    ])
    // tab2操作项冲突解决
    this.$set(this.data, 'conflictOperation2', {
      // edit:{prop:'zt',value:[0]},
      jh: { prop: 'status', value: ['finished', 'ing', 'stop'] },
      zz: { prop: 'status', value: ['finished', 'stop', 'hang'] },
      db: { prop: 'status', value: ['finished', 'stop', 'hang'] },
      zy: { prop: 'status', value: ['stop'] },
      gq: { prop: 'status', value: ['finished', 'hang', 'stop'] },
      th: { prop: 'status', value: ['finished', 'stop'] },
      detail: { prop: 'status', value: ['stop'] }
      // pause:{prop:'zt',value:[3]}
    })
    this.limit = this.table_size[0]
    this.get_instance(this.instance_page)

    this.$set(this.user_panel_data, 'user_list', [])
    this.$set(this.user_panel_data, 'user_select', [])
  },
  methods: {
    // 清空搜索项
    clear () {
      this.keyword_name = ''
      this.date_choose = ''
      this.$set(this.data, 'tableData2', [])
      this.instance_page = 1
      this.get_instance(this.instance_page)
    },
    dateChange () {
      this.$set(this.data, 'tableData2', [])
      this.get_instance(this.instance_page)
    },
    search (val) {
      if (val) {
        this.keyword_name = this.trim(val)
      } else {
        this.keyword_name = ''
      }
      this.$set(this.data, 'tableData2', [])
      this.get_instance(this.instance_page)
    },
    searchSerialNumber (val) {
      if (val) {
        this.keyword_serialnumber = this.trim(val)
      } else {
        this.keyword_serialnumber = ''
      }
      this.$set(this.data, 'tableData2', [])
      this.get_instance(this.instance_page)
    },
    // 私有--切换页面
    change_page (page) {
      this.instance_page = page
      this.get_instance(page)
    },
    // 私有--切换表格数据显示大小
    size_change (size) {
      this.limit = size
      this.get_instance(this.instance_page)
    },
    // 选择人员表格--切换页面
    change_page_choose (page) {
      this.get_user_list(page)
    },
    // 选择人员表格--切换表格数据显示大小
    async size_change_choose (size) {
      this.size_choose = size
      await this.getUserTotal()
      this.get_user_list(1)
    },
    /** *操作处理***/
    // 列表操作设置
    operationHandle (id, operation, rowObj) {
      if (this[`${operation}Handle`]) {
        this.btn_loading = false
        this[`${operation}Handle`](rowObj)
      }
    },
    // 获取实例列表
    get_instance (page) {
      this.loading = true
      var param = {
        fid: this.$route.params.fid,
        page: page,
        limit: this.limit
      }
      if (this.date_choose && this.date_choose.length === 2) {
        param.createtime = this.date_choose[0]
        param.endTime = this.date_choose[1]
      }
      if (this.keyword_name) {
        param.create_by = this.keyword_name
      }
      if (this.keyword_serialnumber) {
        param.serial_number = this.keyword_serialnumber
      }
      service
        .get('/v1/application/getInstance', { params: param })
        .then(res => {
          this.total_count = res.count
          res.data = res.data.map(d => {
            d.status = d.status ? d.status : 'ing'
            d.create_time = this.format_time(d.create_time)
            d.softGroup = this.$store.getters.appInfo.ff_group_name
            return d
          })
          this.$set(this.data, 'tableData2', res.data)
          this.loading = false
        })
        .catch(err => {
          this.$swMessage({
            message: '获取实例列表失败，请稍后再试' + err.message,
            type: 'error'
          })
        })
    },
    detailHandle (data) {
      window.open(`${designFormUrl}/looking?fid=${data.fid}&from=adminplatform&ffid=${data.ffid}&taskid=${data.status === 'stop' || data.status === 'finished' ? data.taskId : data.task_id}&processInstanceId=${data.act_process_id}&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    },
    handleDialogClose (done) {
      this.$swConfirm('确认是否关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {
      })
    },
    // 挂起操作
    gqHandle (data) {
      this.$swConfirm('确定要挂起实例吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          var param = {
            taskId: data.task_id
          }
          service
            .get('/v1/process/hang', { params: param })
            .then(res => {
              if (res.status === 200) {
                this.get_instance(this.instance_page)
                this.$swMessage({
                  message: `${data.act_form_name}挂起成功`,
                  type: 'success'
                })
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: 'error'
                })
              }
            })
            .catch(res => {
              this.$swMessage({
                message: res,
                type: 'error'
              })
            })
        })
        .catch(() => { })
    },
    // 转阅操作
    async zyHandle (data) {
      this.selectlist = []
      this.type_con = false
      this.keyword_radio = ''
      this.keyword_user_name = ''

      this.user_panel_data.name = '确认转阅'
      this.user_panel_data.exp = data
      this.user_panel_data.callback = this.zy_send
      this.user_panel_data.show_user_choose = true

      this.$set(this.data_choose, 'tableTitle', [
        // { prop: 'choose', label: '', width: '20', sortable: false },
        { prop: 'accountName', label: '用户名', width: '120', sortable: true },
        { prop: 'name', label: '真实姓名', width: '120', sortable: true }
      ])
      this.size_choose = this.table_size[0]
      this.$set(this.data_choose, 'total_count', 0)
      this.$set(this.data_choose, 'tableData', [])
      await this.getUserTotal()
      this.get_user_list(1)
    },
    zy_send () {
      if (!this.selectlist || this.selectlist.length === 0) {
        this.$swMessage({
          message: '请选择转阅人员',
          type: 'warning'
        })
        return
      }
      const userId = this.selectlist.map(s => { return s.id })
      var param = {
        taskId: this.user_panel_data.exp.task_id || this.user_panel_data.exp.taskId,
        // userId: this.selectlist[0].value
        userIdList: userId
      }
      this.btn_loading = true
      service
        .post('/v1/process/turnRead', param)
        .then(res => {
          this.btn_loading = false
          this.user_panel_data.show_user_choose = false
          if (res.status === 200) {
            this.get_instance(this.instance_page)
            this.$swMessage({
              message: `${this.user_panel_data.exp.act_form_name}转阅成功`,
              type: 'success'
            })
          } else {
            this.$swMessage({
              message: res.msg,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$swMessage({
            message: res,
            type: 'error'
          })
        })
    },
    // 终止操作
    zzHandle (data) {
      this.$swConfirm('确定要终止实例吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          var param = {
            taskIdList: [data.task_id]
          }
          service
            .post('/v1/process/endProcess', param)
            .then(res => {
              if (res.status === 200) {
                this.get_instance(this.instance_page)
                this.$swMessage({
                  message: `${data.act_form_name}终止成功`,
                  type: 'success'
                })
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: 'error'
                })
              }
            })
            .catch(res => {
              this.$swMessage({
                message: res,
                type: 'error'
              })
            })
        })
        .catch(() => { })
    },
    // 替换办理人
    thHandle (data) {
      console.log(data)
      this.th.task_id = data.task_id
      this.th.processInstanceId = data.act_process_id
      this.th.visible = true
    },
    th_confirm () {
      const selectedRow1 = this.$refs.thTaskTable.selectedRow
      const selectedRow2 = this.$refs.thUserTable.selectedRow
      const id1 = selectedRow1.assignee
      const id2 = selectedRow2.id
      if (!id1) {
        this.$swMessage({
          message: '未选择任务所在人员',
          type: 'warning'
        })
        return
      }
      if (!id2) {
        this.$swMessage({
          message: '未选择任务可转办人员',
          type: 'warning'
        })
        return
      }
      this.$swConfirm(`确定将${selectedRow1.organizationName}的${selectedRow1.realName}的任务转办给${selectedRow2.organizationName}的${selectedRow2.realName}吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.th_send(id1, id2)
      })
    },
    th_send (id1, id2) {
      const params = {
        task_id: this.th.task_id,
        assignee: id1,
        turnUserId: id2,
        processInstanceId: this.th.processInstanceId

      }
      this.th.loading = true
      service
        .post('/v1/process/turnTaskByAdmin', params)
        .then(res => {
          this.th.loading = false
          if (res.flag) {
            this.get_instance(this.instance_page)
            this.$swMessage({
              message: `转办成功`,
              type: 'success'
            })
            this.th.visible = false
          } else {
            this.$swMessage({
              message: res.msg,
              type: 'error'
            })
          }
        })
        .catch(error => {
          console.error(error)
          this.$swMessage({
            message: error,
            type: 'error'
          })
        })
    },
    // 督办
    dbHandle (data) {
      this.$set(this.db_data, 'keyword_db', '')
      this.db_data.show_db = true
      this.db_data.exp = data
    },
    db_send () {
      if (!this.db_data.keyword_db) {
        this.$swMessage({
          message: `请填写督办内容`,
          type: 'error'
        })
        return
      }
      var param = {
        taskId: this.db_data.exp.task_id,
        message: this.db_data.keyword_db
      }
      this.btn_loading = true
      service
        .post('/v1/supervise/superviseTask', param)
        .then(res => {
          this.btn_loading = false
          this.db_data.show_db = false
          this.db_data.keyword_db = ''
          if (res.status === 200) {
            this.get_instance(this.instance_page)
            this.$swMessage({
              message: `${this.db_data.exp.act_form_name}督办成功`,
              type: 'success'
            })
          } else {
            this.$swMessage({
              message: res.msg,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$swMessage({
            message: res,
            type: 'error'
          })
        })
    },
    // 激活操作
    jhHandle (data) {
      this.$swConfirm('确定激活实例吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          var param = {
            taskId: data.task_id
          }
          service
            .get('/v1/process/live', { params: param })
            .then(res => {
              if (res.status === 200) {
                this.get_instance(this.instance_page)
                this.$swMessage({
                  message: `${data.act_form_name}激活成功`,
                  type: 'success'
                })
              } else {
                this.$swMessage({
                  message: res.msg,
                  type: 'error'
                })
              }
            })
            .catch(res => {
              this.$swMessage({
                message: res,
                type: 'error'
              })
            })
        })
        .catch(() => { })
    },
    // 日期格式化
    format_time (sec) {
      const ft = new Date(sec)

      const y = ft.getFullYear()
      const m = ft.getMonth() + 1
      const d = ft.getDate()
      const h = ft.getHours()
      const ms = ft.getMinutes()
      const s = ft.getSeconds()

      const formatNum = num => {
        if (num < 10) {
          return '0' + num
        }
        return num
      }
      return (
        y +
        '-' +
        formatNum(m) +
        '-' +
        formatNum(d) +
        ' ' +
        formatNum(h) +
        ':' +
        formatNum(ms) +
        ':' +
        formatNum(s)
      )
    },
    // 用户
    get_user_list (page) {
      var param = {
        pageNum: page,
        pageSize: this.size_choose
      }
      if (this.trim(this.keyword_user_name)) { param.keyword = this.trim(this.keyword_user_name) }
      this.show_user_tf = true
      service
        .get('/v1/data/share/user/pageTotalUnused', { params: param })
        .then(res => {
          res.data.map(r => {
            r.choose = false
            return r
          })
          this.$set(this.data_choose, 'tableData', res.data)
          this.show_user_tf = false
        })
        .catch(err => {
          this.$swMessage({
            message: err && err.length > 0 ? err : '获取用户列表失败，请稍后重试',
            type: 'error'
          })
        })
    },
    async getUserTotal () {
      const param = {}
      if (this.trim(this.keyword_user_name)) { param.keyword = this.trim(this.keyword_user_name) }
      await service
        .get('/v1/data/share/user/pageTotalCount', { params: param })
        .then(res => {
          this.$set(this.data_choose, 'total_count', res.data.totalCount)
        })
        .catch(err => {
          this.$swMessage({
            message: err && err.length > 0 ? err : '获取用户总数，请稍后重试',
            type: 'error'
          })
        })
    },
    // 搜索用户
    async search_user (val) {
      this.keyword_user_name = this.trim(val)
      await this.getUserTotal()
      this.get_user_list(1)
    },
    // 用户表格选择
    handleChange (val) {
      this.selectlist = val
    },
    // 检测空字符串
    trim (val) {
      if (typeof val === 'string' && val.constructor === String) {
        return val.replace(/(^\s*)|(\s*$)/g, '')
      }
      return val
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@mixin flex-column {
  display: flex;
  flex-direction: column;
}
* {
  font-family: PingFangSC-Medium, PingFangSC;
  padding: 0;
  margin: 0;
}
.font-grey {
  color: rgba(132, 144, 154, 1);
  font-size: 12px;
  // width:36px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
}
.ep {
  .font-grey {
    width: 70px !important;
    font-size: 14px;
    color: rgba(98, 111, 121, 1);
    text-align: right;
  }
  .el-row {
    padding: 8px 10px;
  }
  .el-col {
    display: flex;
    align-items: center;
    padding: 8px 0;
    .ct-panel {
      padding-right: 20px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .font-blue {
      cursor: pointer;
      height: 20px;
      font-size: 14px;
      color: rgba(51, 148, 225, 1);
      line-height: 20px;
      margin-right: 8px;
    }
    .el-select,
    .sw-input,
    .el-date-editor {
      width: 250px;
    }
    .su-icon-arrow {
      cursor: pointer;
      font-size: 14px;
      color: rgba(51, 148, 225, 1);
    }
    .su-icon-arrow-rotate {
      transform: rotate(-180deg);
    }
  }
  .sw-button {
    padding: 5px 16px !important;
    height: 32px;
    font-size: 14px;
    margin-right: 8px;
  }
  ul {
    padding: 18px 20px;
    display: flex;
    li {
      list-style: none;
      margin-right: 8px;
    }
  }
}
.sw-table-unpublish {
  font-size: 12px;
  color: #f5a623;
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: #f5a623;
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
.sw-table-closed {
  font-size: 12px;
  color: rgba(238, 84, 79, 1);
  line-height: 22px;
  &:before {
    width: 8px;
    height: 8px;
    background: rgba(238, 84, 79, 1);
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}
::v-deep .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange{
  height: 32px;
  box-sizing: border-box;
  .el-input__icon{
    height: auto;
  }
  .el-range-separator{
    height: auto;
  }
}
</style>
<style lang="scss">
.table_radio {
  .el-radio__label {
    display: none !important;
  }
}
</style>
